export default "__VITE_ASSET__DHTWueJX__"